import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import Professionals from "@/pages/Professionals";
import ITProjects from "@/pages/ITProjects";
import WhyBleuSharks from "@/pages/WhyBleuSharks";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/professionals" element={<Professionals />} />
            <Route path="/it-projects" element={<ITProjects />} />
            <Route path="/why-bleusharks" element={<WhyBleuSharks />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;
